/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  CreatePackageForm,
  CreatePackageForm$Outbound,
  CreatePackageForm$outboundSchema,
} from "../components/createpackageform.js";

export type CreatePackageSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type CreatePackageSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type CreatePackageSecurity = {
  option1?: CreatePackageSecurityOption1 | undefined;
  option2?: CreatePackageSecurityOption2 | undefined;
};

export type CreatePackageRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  createPackageForm: CreatePackageForm;
};

/** @internal */
export type CreatePackageSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const CreatePackageSecurityOption1$outboundSchema: z.ZodMiniType<
  CreatePackageSecurityOption1$Outbound,
  CreatePackageSecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function createPackageSecurityOption1ToJSON(
  createPackageSecurityOption1: CreatePackageSecurityOption1,
): string {
  return JSON.stringify(
    CreatePackageSecurityOption1$outboundSchema.parse(
      createPackageSecurityOption1,
    ),
  );
}

/** @internal */
export type CreatePackageSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const CreatePackageSecurityOption2$outboundSchema: z.ZodMiniType<
  CreatePackageSecurityOption2$Outbound,
  CreatePackageSecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function createPackageSecurityOption2ToJSON(
  createPackageSecurityOption2: CreatePackageSecurityOption2,
): string {
  return JSON.stringify(
    CreatePackageSecurityOption2$outboundSchema.parse(
      createPackageSecurityOption2,
    ),
  );
}

/** @internal */
export type CreatePackageSecurity$Outbound = {
  Option1?: CreatePackageSecurityOption1$Outbound | undefined;
  Option2?: CreatePackageSecurityOption2$Outbound | undefined;
};

/** @internal */
export const CreatePackageSecurity$outboundSchema: z.ZodMiniType<
  CreatePackageSecurity$Outbound,
  CreatePackageSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => CreatePackageSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => CreatePackageSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function createPackageSecurityToJSON(
  createPackageSecurity: CreatePackageSecurity,
): string {
  return JSON.stringify(
    CreatePackageSecurity$outboundSchema.parse(createPackageSecurity),
  );
}

/** @internal */
export type CreatePackageRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  CreatePackageForm: CreatePackageForm$Outbound;
};

/** @internal */
export const CreatePackageRequest$outboundSchema: z.ZodMiniType<
  CreatePackageRequest$Outbound,
  CreatePackageRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    createPackageForm: CreatePackageForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      createPackageForm: "CreatePackageForm",
    });
  }),
);

export function createPackageRequestToJSON(
  createPackageRequest: CreatePackageRequest,
): string {
  return JSON.stringify(
    CreatePackageRequest$outboundSchema.parse(createPackageRequest),
  );
}
